import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/_general/analytics/reports')({
	staticData: {
		crumb: ({ context: { L } }) => L.Analytics.Reports.Title()
	}
})
